import { MainContents } from "@src/component/home/renewal/main/pc/MainContents";
import { MainFooter } from "@src/component/home/renewal/main/pc/MainFooter";
import { MainGnb } from "@src/component/home/renewal/main/pc/MainGnb";
import { MainLayout } from "@src/component/home/renewal/main/pc/MainLayout";

const MainPage = () => (
	<MainLayout>
		<MainGnb type="client" />
		<MainContents />
		<MainFooter />
	</MainLayout>
);

export default MainPage;
